export const CNPJ_FORMAT = '##.###.###/####-##';

const INVALID_CNPJS = [
  '00000000000000',
  '11111111111111',
  '22222222222222',
  '33333333333333',
  '44444444444444',
  '55555555555555',
  '66666666666666',
  '77777777777777',
  '88888888888888',
  '99999999999999',
];

function invalidate(number, at) {
  const length = number.length + at - 2;
  const numbers = number.substring(0, length);

  let add = 0;
  let pos = length - 7;

  for (let i = length; i >= 1; i -= 1) {
    add += numbers.charAt(length - i) * pos;
    pos -= 1;

    if (pos < 2) {
      pos = 9;
    }
  }

  add = String(add % 11 < 2 ? 0 : 11 - (add % 11));

  if (add !== number.substring(number.length - 2).charAt(at)) {
    return true;
  }

  return false;
}

export default function cnpj(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const number = String(value).replace(/\D/g, '');

  if (!number || number.length !== 14) {
    return true;
  }

  if (INVALID_CNPJS.indexOf(number) > -1) {
    return true;
  }

  if (invalidate(number, 0)) {
    return true;
  }

  if (invalidate(number, 1)) {
    return true;
  }

  return false;
}

cnpj.message = function message(value, options = {}) {
  return options.message || 'não é um CNPJ válido';
};
